import { render, staticRenderFns } from "./GetStartedSuccess.vue?vue&type=template&id=6d53e696&scoped=true&"
import script from "./GetStartedSuccess.vue?vue&type=script&lang=js&"
export * from "./GetStartedSuccess.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedSuccess.vue?vue&type=style&index=0&id=6d53e696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53e696",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VProgressCircular,VRow})
